import React, { memo } from "react";



const Tooltip = memo(({ text, children, position = 'top' }) => {
    // Set up the positioning classes for the tooltip and arrow
    const positions = {
      top: 'absolute -top-10 left-1/2 -translate-x-1/2',
      bottom: 'absolute top-full left-1/2 -translate-x-1/2',
      left: 'absolute left-6 top-1/2 -translate-y-1/2',
      right: 'absolute right-0 top-1/2 -translate-y-1/2',
      'bottom-right': 'absolute top-full right-0 translate-y-2',
      'bottom-left': 'absolute top-full left-0 translate-y-2', // Added bottom-left
    };
    
    const arrowPositionClasses = {
      top: 'before:top-full before:border-t-black',
      bottom: 'before:-top-2 before:border-b-black',
      left: 'before:right-full before:top-1/2 before:-translate-y-1/2 before:border-r-black',
      right: 'before:left-full before:top-1/2 before:-translate-y-1/2 before:border-l-black',
      'bottom-right': 'before:-top-2 before:right-4 before:border-b-black',
      'bottom-left': 'before:-top-2 before:left-4 before:border-b-black', // Arrow for bottom-left
    };
  
    return (
      <span className="group relative z-40 overflow-visible">
        <span
          className={`pointer-events-none z-30 ${positions[position]} whitespace-nowrap rounded bg-black px-2 py-1 text-white opacity-0 transition before:absolute before:left-1/2 before:-translate-x-1/2 before:border-4 before:border-transparent before:content-[''] group-hover:opacity-100 ${arrowPositionClasses[position]}`}
        >
          {text}
        </span>
        {children}
      </span>
    );
  });
  
  Tooltip.displayName = "Tooltip";
  export default Tooltip
  
